import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '电影', href: '/category/movie' },
  { label: '电视剧', href: '/category/tv-series' },
  { label: '综艺', href: '/category/variety' },
  { label: '动漫', href: '/category/anime' },
  { label: '纪录片', href: '/category/documentary' },
  { label: '短视频', href: '/category/short-video' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const navbarBg = isHome && !scrolled
    ? 'bg-transparent'
    : 'bg-background-50/95 backdrop-blur-md';

  const textColor = isHome && !scrolled
    ? 'text-white'
    : 'text-foreground-900';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navbarBg} ${
        scrolled ? 'border-b border-background-200/60' : ''
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className={`flex items-center gap-2 ${textColor}`}>
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-fill text-white text-lg"></i>
            </div>
            <span className="text-lg font-heading whitespace-nowrap">91视频网站</span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                  location.pathname === link.href
                    ? scrolled || !isHome
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-white/20 text-white'
                    : isHome && !scrolled
                      ? 'text-white/80 hover:text-white hover:bg-white/10'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <div className={`relative ${textColor}`}>
              <input
                type="text"
                placeholder="搜索视频..."
                className={`pl-9 pr-4 py-2 rounded-full text-sm border outline-none transition-all duration-200 w-48 focus:w-64 ${
                  isHome && !scrolled
                    ? 'bg-white/15 border-white/20 text-white placeholder-white/60 focus:bg-white/25'
                    : 'bg-background-100 border-background-200 text-foreground-900 placeholder-foreground-400 focus:border-primary-400'
                }`}
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm"></i>
            </div>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                isHome && !scrolled
                  ? 'border border-white/30 text-white hover:bg-white/10'
                  : 'border border-foreground-300 text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg ${textColor}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 animate-in slide-in-from-top-2">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`block px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.href
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-2 border-t border-background-200">
              <Link
                to="/about"
                className="block px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-600 hover:bg-background-100"
              >
                关于我们
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}